import 'reflect-metadata';
import './polyfills';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { container, inject, IocProvider } from '@vk-hr-tek/core/ioc';
import { monitoringInit } from '@vk-hr-tek/core/monitoring/monitoringInit';

import { createStore } from '@app/store';
import { AppUpdator } from '@app/services';

import { serviceWorkerRegister } from './serviceWorkerRegister';
import App from './App';

const { store, injectReducer } = createStore();

const updator = inject<AppUpdator>(AppUpdator);
updator.setDispatch(store.dispatch);
updator.restore();

monitoringInit();

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <IocProvider container={container}>
      <App injectReducer={injectReducer} />
    </IocProvider>
  </Provider>,
);

serviceWorkerRegister();
